var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,[React.createElement("g",{"fill":"#090e24","key":0},[React.createElement("use",{"xlinkHref":"#B","key":0}),React.createElement("use",{"xlinkHref":"#B","y":"10.586","key":1}),React.createElement("use",{"xlinkHref":"#B","y":"21.172","key":2})]),React.createElement("defs",{"key":1},React.createElement("path",{"id":"B","d":"M.584.584h0a.82.82 0 0 1 1.16 0l7.13 7.13a.82.82 0 0 0 1.16 0l7.14-7.13a.82.82 0 0 1 1.16 0h0a.82.82 0 0 1 0 1.16l-8.29 8.29-.58.55-.58-.55-8.29-8.29c-.33-.33-.33-.84-.01-1.16z"}))]);
}

ChevronDown.defaultProps = {"viewBox":"0 0 18.9 31.76","xmlnsV":"https://vecta.io/nano"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;
